/* NOTE: Resolving 'eslint-disable prefer-arrow-functions'
// will require architecture and refactoring of the entire WW engine
*/

/* eslint-disable @typescript-eslint/consistent-type-assertions */
import { CoreControlType } from '../../../class/workflow.type';
import { workflowBuildingBlockRegistry } from '../../shared/workflow-registries';

/** BuildingBlock decorator */
// eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
export function CoreBuildingBlock(controlType: CoreControlType) {
  return (target) => BuildingBlockBase(controlType, target);
}

export const BuildingBlockBase = <T>(controlType: CoreControlType | T, target) => {
  // eslint-disable-next-line @typescript-eslint/tslint/config
  const key = <string>controlType;
  if (!workflowBuildingBlockRegistry[key]) {
    workflowBuildingBlockRegistry[key] = target;
  }
};
